import axios from './axiosInstance';
// 

const serviceEnv = 'OnRequest' // 'Test' or 'OnRequest'

const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};


const BinLookup=({bin}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.get(`https://lookup.binlist.net/${bin}`)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetPosRatio=({token,payload}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`https://europe-west1-kolayyol-la.cloudfunctions.net/getPosRatio${serviceEnv}`,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetVirtualPOS=({token,payload}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`https://europe-west1-kolayyol-la.cloudfunctions.net/getVirtualPOS${serviceEnv}`,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const ListCards=({token,payload, corsSecure}) => {
    setDefaults()
    const serviceUri = corsSecure ? `payment/listCards`  :`https://europe-west1-kolayyol-la.cloudfunctions.net/listCards${serviceEnv}`
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(serviceUri ,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


const SaveCard=({token,payload, corsSecure}) => {
    setDefaults()
    const serviceUri = corsSecure ? `payment/saveCard`  :`https://europe-west1-kolayyol-la.cloudfunctions.net/saveCard${serviceEnv}`

    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(serviceUri,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


const RemoveCard=({token,payload, corsSecure}) => {
    setDefaults()
    const serviceUri = corsSecure ? `payment/removeCard`  :`https://europe-west1-kolayyol-la.cloudfunctions.net/removeCard${serviceEnv}`

    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(serviceUri,payload)
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {reject(error.response)})
    })
}

const PurchaseBySavedCard=({token,payload, corsSecure}) => {
    setDefaults()
    const serviceUri = corsSecure ? `payment/purchaseBySavedCard`  :`https://europe-west1-kolayyol-la.cloudfunctions.net/purchaseBySavedCard${serviceEnv}`

    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(serviceUri,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const Purchase=({token,payload}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`https://europe-west1-kolayyol-la.cloudfunctions.net/purchase${serviceEnv}`,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}
const GetReceiptDetail=({token,payload}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`https://europe-west1-kolayyol-la.cloudfunctions.net/getReceiptDetail${serviceEnv}`,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const Refund=({token,payload}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`https://europe-west1-kolayyol-la.cloudfunctions.net/refund${serviceEnv}`,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const CreateProvisionBySavedCard=({token, payload, corsSecure}) => {
    setDefaults()
    const serviceUri = corsSecure ? `payment/createProvisionBySavedCard`  :`https://europe-west1-kolayyol-la.cloudfunctions.net/createProvisionBySavedCard${serviceEnv}`
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(serviceUri,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}
const PurchaseByProvision=({token,payload}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`https://europe-west1-kolayyol-la.cloudfunctions.net/purchaseByProvision${serviceEnv}`,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const CancelProvision=({token,payload}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`https://europe-west1-kolayyol-la.cloudfunctions.net/cancelProvision${serviceEnv}`,payload)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}



export {
    BinLookup,
    GetPosRatio,
    GetVirtualPOS,
    ListCards,
    SaveCard,
    RemoveCard,
    PurchaseBySavedCard,
    Purchase,
    GetReceiptDetail,
    Refund,
    CreateProvisionBySavedCard,
    PurchaseByProvision,
    CancelProvision,
}


